module.exports = __webpack_public_path__ + "static/media/avatar-queiroz.cfe1517d.png";